import { render, staticRenderFns } from "./CustomerOnHoldModal.vue?vue&type=template&id=04276bb8"
import script from "./CustomerOnHoldModal.vue?vue&type=script&lang=ts"
export * from "./CustomerOnHoldModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports